const InfoCircleIconAlert = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={17}
      viewBox="0 0 16 17"
      fill="none"
    >
      <g clipPath="url(#clip0_975_2088)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.09998 8.99998C1.09998 5.18921 4.18921 2.09998 7.99998 2.09998C11.8107 2.09998 14.9 5.18921 14.9 8.99998C14.9 12.8107 11.8107 15.9 7.99998 15.9C4.18921 15.9 1.09998 12.8107 1.09998 8.99998ZM7.99997 7C8.55225 7 8.99997 6.55228 8.99997 6C8.99997 5.44772 8.55225 5 7.99997 5C7.44768 5 6.99997 5.44772 6.99997 6C6.99997 6.55228 7.44768 7 7.99997 7ZM7.99997 7.90002C8.4418 7.90002 8.79997 8.2582 8.79997 8.70002V12.3C8.79997 12.7419 8.4418 13.1 7.99997 13.1C7.55814 13.1 7.19997 12.7419 7.19997 12.3V8.70002C7.19997 8.2582 7.55814 7.90002 7.99997 7.90002Z"
          fill="#E3CB17"
        />
      </g>
      <defs>
        <clipPath id="clip0_975_2088">
          <rect
            width={16}
            height={16}
            fill="white"
            transform="translate(0 1)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default InfoCircleIconAlert;
